module.exports = __webpack_public_path__ + "media/styles/images/svg/logo-11fa31ff53e68327073ab01823d6e574.svg";